// Central registry for data-testid values across the Wen Jie Studio site.
export const NAV = {
  root: "site-nav",
  logo: "nav-logo",
  linkHome: "nav-link-home",
  linkAbout: "nav-link-about",
  linkServices: "nav-link-services",
  linkWork: "nav-link-work",
  linkProcess: "nav-link-process",
  linkContact: "nav-link-contact",
  cta: "nav-cta-chat",
  mobileToggle: "nav-mobile-toggle",
  mobileMenu: "nav-mobile-menu",
};

export const HERO = {
  root: "hero-section",
  headline: "hero-headline",
  sub: "hero-sub",
  ctaPrimary: "hero-cta-primary",
  ctaSecondary: "hero-cta-secondary",
  canvas: "hero-canvas",
  scrollHint: "hero-scroll-hint",
};

export const ABOUT = {
  root: "about-section",
  heading: "about-heading",
  card: (key) => `about-card-${key}`,
};

export const SERVICES = {
  root: "services-section",
  heading: "services-heading",
  card: (slug) => `service-card-${slug}`,
};

export const WORK = {
  root: "work-section",
  heading: "work-heading",
  card: (slug) => `work-card-${slug}`,
};

export const PROCESS = {
  root: "process-section",
  heading: "process-heading",
  step: (slug) => `process-step-${slug}`,
};

export const TOOLS = {
  root: "tools-section",
  heading: "tools-heading",
  item: (slug) => `tools-item-${slug}`,
};

export const CONTACT = {
  root: "contact-section",
  heading: "contact-heading",
  linkedin: "contact-linkedin",
  instagram: "contact-instagram",
  facebook: "contact-facebook",
  email: "contact-email",
};

export const FOOTER = {
  root: "site-footer",
};

export const HOME = {
  emergentLink: "home-emergent-link",
};
